module.exports = __webpack_public_path__ + "img/background-pos-detail.e29fc763.svg";